import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import InfoBlock from '../../features/components/InfoBlock'
import ProgressButton from '../../components/Form/ProgressButton'
import { ReactComponent as WorkSpace } from '../../assets/icons/work-space.svg'

import {
  acceptedInviteErrorSelector,
  acceptedInviteIsLoadingSelector,
  inviteWasAcceptedSelector
} from '../../modules/selectors/team'
import { acceptInvite, clearAcceptInvite, deleteInvite } from '../../modules/actions/team'

import { capitalizeFirstLetter } from '../../helpers/common'

import useStyles from './styles'

const AcceptAccountInvite = ({ invite, setAtLeastOneInviteAccepted }) => {
  const classes = useStyles()

  const { t } = useTranslation()
  const dispatch = useDispatch()

  const { token, id, accounts } = invite

  const accountInviteWasAccepted = useSelector(inviteWasAcceptedSelector)
  const acceptedInviteIsLoading = useSelector(acceptedInviteIsLoadingSelector)
  const acceptedInviteError = useSelector(acceptedInviteErrorSelector)

  const acceptAccountInviteHandler = () => {
    dispatch(acceptInvite({ token }, false, true))
  }

  const deleteAccountInviteHandler = () => {
    dispatch(deleteInvite(id, true))
  }

  const manyAccountsInvitationMessage = accounts => {
    return (
      <p>
        {accounts.map((account, index) => {
          return index < accounts.length - 1 ? (
            <span>{capitalizeFirstLetter(account.name)} and </span>
          ) : (
            <span>{capitalizeFirstLetter(account.name)}</span>
          )
        })}
        {t(' want to add you to their accounts')}
      </p>
    )
  }

  const oneAccountInvitationMessage = accounts => {
    return (
      <p>
        {accounts[0].name}
        {t(' wants to add you to their account')}
      </p>
    )
  }

  const onSuccessInviteAccept = () => {
    setAtLeastOneInviteAccepted(true)
  }

  const clearAcceptAccountInviteHandler = () => {
    dispatch(clearAcceptInvite())
  }

  return (
    <>
      <InfoBlock Icon={WorkSpace} title={t('You’ve been invited to join an account!')}>
        {accounts.length === 1 ? oneAccountInvitationMessage(accounts) : manyAccountsInvitationMessage(accounts)}
      </InfoBlock>
      <div className={classes.inviteButtonsWrapper}>
        <ProgressButton
          className={classes.button}
          isFormLoading={acceptedInviteIsLoading}
          formError={acceptedInviteError}
          onClick={acceptAccountInviteHandler}
          successSubmit={accountInviteWasAccepted}
          clearHandler={clearAcceptAccountInviteHandler}
          onSuccessSubmit={onSuccessInviteAccept}
        >
          Accept
        </ProgressButton>
        <div>
          {t('Was this in error?')}{' '}
          <span className={classes.decline} onClick={deleteAccountInviteHandler}>
            {t('Decline')}
          </span>
        </div>
      </div>
    </>
  )
}

export default AcceptAccountInvite
